// ADIRATH website — central image map.
// All images are self-hosted in public/photos/ and public/certs/.
// Run download-photos.ps1 once to fetch the eeepvtltd.com and extra Unsplash photos.

const P = (name) => `/photos/${name}`

const MAP = {
  // Hero banners
  'hero-bess':       P('hero-banner-1.webp'),
  'bess-page-hero':  P('service-bess.webp'),
  'hero-mobility':   P('2.webp'),
  'hero-solar':      P('Aerial shot of photovoltaic panels in solar power station.webp'),
  'hero-robotics':   P('robotics-1.webp'),
  'hero-automation': P('industrialRobotarm.webp'),
  'hero-npd':        P('hero-npd-adirath.webp'),

  // Service / segment images
  'bess':       P('service-bess.webp'),
  'mobility':   P('2.webp'),
  'robotics':   P('robotics-2.webp'),
  'automation': P('industrialRobotarm.webp'),
  'solar':      P('solar.webp'),
  'solar2':     P('solar-panels-roof-solar-cell.webp'),
  'solar3':     P('Solaranlage, Photovoltaik, Solar Panele.webp'),
  'npd':        P('hero-npd-adirath.webp'),

  // Robotics variants
  'robotics-1': P('robotics-1.webp'),
  'robotics-2': P('robotics-2.webp'),
  'robotics-3': P('robotics-3.webp'),
  'robotics-4': P('robotics-4.webp'),
  'robotics-5': P('robotics-5.webp'),
  'robotics-6': P('robotics-6.webp'),
  'robotics-8': P('robotics-8.webp'),

  // Automation variants
  'automation2': P('PLC_Automation.webp'),
  'automation3': P('PLC_Automation_1.webp'),
  'automation4': P('Pneumatic Automation.webp'),

  // Generic / page heroes
  'facility': P('facility.webp'),

  // Gallery / misc
  'g5': P('g5.webp'),
  'g8': P('g8.webp'),
  'careers-section': P('careers_section.webp'),

  // Company photos
  'co-vision':   P('co-vision.webp'),
  'co-core':     P('co-core.webp'),
  'co-mission':  P('co-mission.webp'),
  'co-teams':    P('co-teams.webp'),
  'co-about':    P('co-about.webp'),
  'co-facility': P('co-facility.webp'),
  'factory-1':   P('factory_1.webp'),
  'factory-2':   P('factory_2.webp'),

  // Process — battery pack production
  'pp-cell':  P('pp-cell.webp'),
  'pp-bms':   P('pp-bms.webp'),
  'pp-weld':  P('pp-weld.webp'),
  'pp-pcb':   P('pp-pcb.webp'),
  'pp-pack':  P('pp-pack.webp'),

  // Process — robotics & automation
  'pr-req':     P('pr-req.webp'),
  'pr-design':  P('pr-design.webp'),
  'pr-comp':    P('pr-comp.webp'),
  'pr-proto':   P('pr-proto.webp'),
  'pr-impl':    P('pr-impl.webp'),
  'pr-train':   P('pr-train.webp'),
  'pr-support': P('pr-support.webp'),
  'pr-autom':   P('pr-autom.webp'),
  'pr-npd':     P('pr-npd.webp'),

  _fallback: P('hero-bess-adirath.webp'),
}

export const IMG = (key) => MAP[key] || MAP._fallback
export const ADR_IMAGES = MAP
